const RESPONSIVE_RULES = [
  {
    breakpoint: 1260,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      infinite: false,
    },
  },
  {
    breakpoint: 720,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
    },
  },
];

export const SETTINGS = ({ toSeeNext, slidesToShow, beforeChange }) => {
  const className = `ShopDevicesSlider ${toSeeNext ? 'ScrollMenu--toSeeNext' : ''}`;
  const resp = {
    accessibility: true,
    arrows: true,
    className,
    slide: 'div',
    draggable: false,
    slidesToShow,
    slidesToScroll: slidesToShow,
    dots: true,
    infinite: false,
    speed: 500,
    variableWidth: false,
    beforeChange: beforeChange,
    responsive: RESPONSIVE_RULES,
  };
  return resp;
};